var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { PureComponent } from "react";
class SaveButton extends PureComponent {
    constructor(props) {
        super(props);
        this.save = this.save.bind(this);
        this.state = {
            saving: false,
        };
    }
    save() {
        this.setState({ saving: true }, () => __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.props.onSave();
            }
            catch (ex) {
                console.error("Exception While Saving: ", ex);
            }
            this.setState({ saving: false });
        }));
    }
    render() {
        if (this.state.saving) {
            return (_jsx("button", { className: `btn btn-success col-${this.props.col || 12}`, type: "button", children: _jsx("i", { className: "center-block fal fa-circle-notch fa-spin fa-fw" }) }));
        }
        return (_jsx("button", { className: `btn btn-success col-${this.props.col || 12}`, onClick: this.save, type: "button", children: "Save" }));
    }
}
export default SaveButton;
